export default __webpack_public_path__ + "static/media/AngleRightLight.225d296e.svg";